export const UserRoles = {
  SUPER_ADMIN: "SUPER_ADMIN",
  ORG_ADMIN: "ORG_ADMIN",
  ORG_MEMBER: "ORG_MEMBER",
  ORG_GUEST: "ORG_GUEST",
} as const

export const ROLE_HIERARCHY: Record<UserRole, UserRole[]> = {
  [UserRoles.SUPER_ADMIN]: [
    UserRoles.ORG_ADMIN,
    UserRoles.ORG_MEMBER,
    UserRoles.ORG_GUEST,
  ],
  [UserRoles.ORG_ADMIN]: [UserRoles.ORG_MEMBER, UserRoles.ORG_GUEST],
  [UserRoles.ORG_MEMBER]: [UserRoles.ORG_GUEST],
  [UserRoles.ORG_GUEST]: [],
} as const

export type UserRole = (typeof UserRoles)[keyof typeof UserRoles]
